import React, { useEffect } from "react";
import { Alert, Input, Label, Form, FormFeedback } from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { registerUser, apiError } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import { Link, useNavigate } from "react-router-dom";

// import images
import logoImg from "../../assets/images/logo.svg";

const Register = props => {

  //meta title
  document.title = "Register | Skote - React Admin & Dashboard Template";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
      username: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      username: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(registerUser(values));
    }
  });


  const AccountProperties = createSelector(
    (state) => state.Account,
    (account) => ({
      user: account.user,
      registrationError: account.registrationError,
      success: account.success
      // loading: account.loading,
    })
  );

  const {
    user,
    registrationError, success
    // loading
  } = useSelector(AccountProperties);

  useEffect(() => {
    dispatch(apiError(""));
  }, []);

  useEffect(() => {
    success && setTimeout(() => navigate("/login"), 2000)
  }, [success])

  return (
    <React.Fragment>
      <div className="auth-modern-wrapper">
        <div className="auth-modern-card">
          <div className="auth-modern-logo">
            <img src={logoImg} alt="" height="24" />
          </div>
          <h4 className="auth-modern-title">Create an account</h4>
          <p className="auth-modern-subtitle">Get your free RealtySpace account now</p>

          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            {user && user ? (
              <Alert color="success">
                Register User Successfully
              </Alert>
            ) : null}

            {registrationError && registrationError ? (
              <Alert color="danger">{registrationError}</Alert>
            ) : null}

            <div className="mb-3">
              <Label className="form-label">Email</Label>
              <Input
                id="email"
                name="email"
                className="form-control"
                placeholder="Enter email"
                type="email"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.email || ""}
                invalid={
                  validation.touched.email && validation.errors.email ? true : false
                }
              />
              {validation.touched.email && validation.errors.email ? (
                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              <Label className="form-label">Username</Label>
              <Input
                name="username"
                type="text"
                placeholder="Enter username"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.username || ""}
                invalid={
                  validation.touched.username && validation.errors.username ? true : false
                }
              />
              {validation.touched.username && validation.errors.username ? (
                <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
              ) : null}
            </div>
            <div className="mb-3">
              <Label className="form-label">Password</Label>
              <Input
                name="password"
                type="password"
                placeholder="Enter Password"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.password || ""}
                invalid={
                  validation.touched.password && validation.errors.password ? true : false
                }
              />
              {validation.touched.password && validation.errors.password ? (
                <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
              ) : null}
            </div>

            <div className="mt-4 d-grid">
              <button
                className="btn btn-primary"
                type="submit"
              >
                Register
              </button>
            </div>
          </Form>

          <div className="auth-modern-footer">
            Already have an account?{" "}
            <Link to="/login" className="text-primary fw-medium">
              Login
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Register;
